import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router'

import { routerTransition } from './router.animations';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [routerTransition]
})
export class AppComponent {
  getState(outlet) {
    return outlet.activatedRouteData.state;
  }

  // ***************************** //

  constructor(private router: Router) { }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo({
        left: 0, top: 0,
        behavior: 'smooth',
      })
    });
  }
}
